import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {RiskFactorsValidExpands, getRiskFactors} from '../../../../actions/RiskFactor/riskfactoractions';
import DefineRiskList from './DefineRiskList';
import {groupRiskFactorByFormHeader} from '../../../../reducers/RiskFactor/riskFactorReducer';
import {useOverrideLabels} from '../../../Main/Forms/Utilities/OverrideLabelsProvider';
import {useAresUrlParameters, useSelectedStEntityId} from '../../../../util/Ares/customHooks';
import {getTaskDocumentByDocumentId} from '../../../../selectors/Ares/selectors';
import {isNullOrUndefined} from '../../../../util/utils';

const DefineRisks = (props) => {
	const dispatch = useDispatch();
	const engagementId = useSelector((state) => state.engagementId);
	const {documentId} = useAresUrlParameters();
	const document = useSelector((state) => getTaskDocumentByDocumentId(state, documentId));
	const risks = useSelector((state) => state.risks);
	const riskFactors = useSelector((state) => state.riskFactors);
	const [riskFactorsGroupByHeader, setRiskFactorsGroupByHeader] = useState([]);
	const [selectedStEntityId] = useSelectedStEntityId();

	const {labels} = useOverrideLabels();

	useEffect(() => {
		const getAllRiskFactorsAsync = async () => {
			await getAllRiskFactors();
		};

		getAllRiskFactorsAsync().then((r) => r);
	}, [risks, selectedStEntityId]); //Should trigger when Manage Risks modal has changes

	useEffect(() => {
		if (riskFactors?.length > 0) {
			setRiskFactorsGroupByHeader(groupRiskFactorByFormHeader(riskFactors));
		}
	}, [riskFactors]);

	const getAllRiskFactors = async () => {
		dispatch(
			getRiskFactors(engagementId, {
				expand: RiskFactorsValidExpands.formHeaders,
				filterMultiEntityIds: selectedStEntityId
					? selectedStEntityId
					: !isNullOrUndefined(document?.stEntityId)
					? document.stEntityId
					: undefined
			})
		);
	};

	return (
		<>
			<StyledDefineRisksSummary className={props.className}>
				<div className="assesssdefinerisk-accordion">
					{/* <span className="header">{labels.identifiedRiskFactorsTitle}</span> */}
					<ul>
						{riskFactorsGroupByHeader.length > 0 ? (
							riskFactorsGroupByHeader.map((header) => (
								<>
									<DefineRiskList
										key={header.formHeaderId}
										headerName={header.riskFactors[0].formHeaderName}
										riskFactorsList={header.riskFactors}
										taskShortName={header.riskFactors[0].taskShortName}
									/>
								</>
							))
						) : (
							<section className="empty-template">
								<span className="no-risksfactor">{labels.noResponseAvailable}</span>
							</section>
						)}
					</ul>
				</div>
			</StyledDefineRisksSummary>
		</>
	);
};

export default DefineRisks;

const StyledDefineRisksSummary = styled.section`
	padding: var(--px-30) var(--px-155);
	margin-bottom: var(--px-30);
	cursor: default;
	.empty-template {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: start;
		justify-content: center;
		cursor: default;
		margin-left: calc(var(--px-15) * -1);
		.no-risks {
			color: var(--neutrals-700);
			font-size: var(--px-12);
			font-weight: 300;
			padding: var(--px-5) 0 var(--px-13) 0;
		}
		.no-risksfactor {
			color: var(--neutrals-700);
			font-size: var(--px-12);
			font-weight: 300;
			padding: var(--px-5) 0 var(--px-13) var(--px-15);
		}
	}
	.assesssdefinerisk-accordion {
		box-shadow: none;
		border-radius: 0;
		background: none;
		border: none;
		.motif-accordion-icons svg {
			fill: var(--blue-600);
		}
		span {
			display: block;
		}
		span.motif-icon {
			display: inline-block;
		}
		.header {
			font-size: var(--px-14);
			font-weight: bold;
			padding-bottom: var(--px-15);
		}
		.riskfactor-type {
			font-size: var(--px-14);
			font-weight: bold;
			padding-bottom: var(--px-15);
			* > span {
				display: inline;
			}
		}
		.riskfactor-typelist {
			padding-left: var(--px-20);
			li {
				margin-bottom: var(--px-15);
			}
			.riskfactor-name {
				font-size: var(--px-14);
				font-weight: 400;
				padding-bottom: var(--px-5);
			}
			.riskfactor-description {
				font-size: var(--px-12);
				font-weight: 300;
				padding-bottom: var(--px-5);
				&.description-incomplete {
					color: var(--neutrals-700);
					.motif-icon {
						color: var(--neutrals-700);
						margin-right: var(--px-3);
						svg {
							width: var(--px-16) !important;
							height: var(--px-16) !important;
							vertical-align: text-bottom;
						}
					}
				}
			}
			.related-risks {
				&.rationale-ellipse {
					margin-left: var(--px-40);
					.rationale-entered {
						font-size: var(--px-12);
						font-weight: 300;
						padding-top: var(--px-5);
						padding-left: 0;
						* > span {
							display: inline;
						}
					}
				}
				.no-relatedrisk {
					font-size: var(--px-12);
					font-weight: 300;
					padding-left: var(--px-28);
					color: var(--neutrals-700);
				}
				.relatedrisk-name {
					display: inline-block;
					padding-left: var(--px-10);
					font-size: var(--px-12);
					font-weight: normal;
					max-width: 95%;
					.motif-icon {
						color: var(--green-500);
						margin-right: var(--px-3);
						svg {
							width: var(--px-16) !important;
							height: var(--px-16) !important;
							vertical-align: text-bottom;
						}
					}
				}
				.risk-badge {
					display: inline-block;
					margin-left: var(--px-10);
				}
				.rationale-entered {
					font-size: var(--px-12);
					font-weight: 300;
					padding-left: var(--px-40);
					padding-top: var(--px-5);
					* > span {
						display: inline;
					}
					&.rationale-incomplete {
						color: var(--neutrals-700);
						padding-left: var(--px-40);
						.motif-icon {
							color: var(--neutrals-700);
							margin-right: var(--px-3);
							svg {
								width: var(--px-16) !important;
								height: var(--px-16) !important;
								vertical-align: text-bottom;
								cursor: default;
							}
						}
					}
				}
			}
		}
	}
`;
